import { useState, useEffect, useRef } from 'react';

export function useScrollSpyNav(sectionIds: string[], initialActiveId?: string) {
  const [activeId, setActiveId] = useState(initialActiveId || sectionIds[0] || '');
  const [userInteractionMode, setUserInteractionMode] = useState<'scroll' | 'click'>('scroll');
  const sectionRefs = useRef<Map<string, HTMLElement | null>>(new Map());
  const interactionTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleItemClick = (id: string) => {
    if (interactionTimeoutRef.current) {
      clearTimeout(interactionTimeoutRef.current);
    }

    setUserInteractionMode('click');
    setActiveId(id);

    const element = sectionRefs.current.get(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      // Add focus management
      element.focus({ preventScroll: true });
    }

    // Reset to scroll-based interaction after a delay
    interactionTimeoutRef.current = setTimeout(() => {
      setUserInteractionMode('scroll');
    }, 1500); // Adjust timeout as needed
  };

  const handleSectionInView = (id: string) => {
    if (userInteractionMode === 'scroll') {
      setActiveId(id);
    }
  };

  useEffect(() => {
    return () => {
      if (interactionTimeoutRef.current) clearTimeout(interactionTimeoutRef.current);
    };
  }, []);

  return {
    activeId,
    sectionRefs,
    handleItemClick,
    handleSectionInView,
  };
}
